import { Link } from "react-router-dom";
import BookButton from "@/components/BookButton";
import { trackClick } from "@/lib/analytics";

export default function CelebrateSection() {
  return (
    <section className="bg-ember-light py-24 md:py-32 relative overflow-hidden" data-testid="celebrate-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-10 md:gap-16 items-center">
        <div className="md:col-span-6 grid grid-cols-12 gap-3">
          <div className="col-span-8 aspect-[4/3] overflow-hidden">
            <img
              src="/images/property/king-room-angle.jpg"
              alt="Jacuzzi Suite king bed at Westbridge Inn & Suites"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="col-span-4 self-end aspect-[3/4] overflow-hidden">
            <img
              src="/images/property/led-mirror-bathroom.jpg"
              alt="LED-lit bathroom mirror in the Jacuzzi Suite"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        </div>
        <div className="md:col-span-6">
          <p className="font-mono-label text-ember mb-4">Celebrate at Westbridge</p>
          <h2 className="font-display text-5xl md:text-6xl text-ink leading-[1.02]">
            An anniversary,<br />
            <span className="italic text-ember">a jacuzzi, and quiet.</span>
          </h2>
          <p className="mt-6 text-ink-soft text-lg leading-relaxed max-w-xl">
            Our Jacuzzi Suite is the room guests book when the night matters — anniversaries,
            birthdays, honeymoon stopovers, or simply a getaway from the noise. A king bed, a
            private in-room jacuzzi hot tub, an LED-lit bath, and the kind of rural Missouri
            quiet you can't buy in a city. Hot breakfast for two comes with it.
          </p>
          <div className="mt-6 flex items-baseline gap-3">
            <span className="font-display text-5xl text-ember" data-testid="celebrate-price">$139</span>
            <span className="font-mono-label text-ink-muted">per night · Jacuzzi Suite</span>
          </div>
          <div className="mt-8 flex flex-wrap gap-3">
            <BookButton label="Reserve the Jacuzzi Suite" testid="celebrate-book-btn" />
            <Link
              to="/accommodations"
              onClick={() => trackClick("celebrate:view-suite")}
              className="btn-ink"
              data-testid="celebrate-view-suite"
            >
              See the suite
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
